import * as React from "react";
import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Input, InputProps, Label, makeStyles, Text, tokens } from "@fluentui/react-components";
import { deleteAuction, getAuctions, saveAuction, getOffersByAuction } from "../services/AuctionService";
import { IAuction } from "../models/auction";
import { DeleteFilled, EditFilled, ClockRegular } from "@fluentui/react-icons";
import { IBestOffer } from "../models/offer";
import { format } from "date-fns";

export const AuctionList = () => {
  const [auctions, setAuctions] = useState<IAuction[]>([]);
  const [offers, setOffers] = useState<IBestOffer[]>([]);
  const [open, setOpen] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [auction, setAuction] = useState<IAuction>();
  const [error, setError] = useState('');
  const [jersey, setJersey] = useState<string>();
  const [team, setTeam] = useState<string>();
  const [name, setName] = useState<string>();

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const result = await getAuctions();
      console.log(result);
      setAuctions(result);
    };
    fetchData().catch(console.error)
  }, []);

  const handleAdd = () => {
    const auction: IAuction = { ID: '-1', Fullname: '' }
    setAuction(auction);
    setJersey('');
    setTeam('');
    setName('');
    setOpen(true);
  }

  const handleEdit = (auction: IAuction) => {
    console.log(auction);
    setAuction(auction);
    setJersey(auction?.JerseyNumber);
    setTeam(auction?.Team);
    setName(auction?.Fullname);
    setOpen(true);
  }

  const handleDelete = async (auction: IAuction) => {
    console.log(auction);
    const res = await deleteAuction(auction);
    if(res === true) {
      setOpen(false);
      const res1 = await getAuctions();
      setAuctions(res1);
    }
  }

  const handleHistory = async (auction: IAuction) => {
    console.log(auction);    
    const res = await getOffersByAuction(auction.ID);
    setOffers(res);
    setShowDetail(true);  
  }

  const onSave = async () => {
    const a: IAuction = { 
      ID: auction === undefined ? '-1' : auction.ID,
      Fullname: name ?? '',
      JerseyNumber: jersey,
      Team: team
    }
    const res = await saveAuction(a);
    console.log(res);
    if(res !== undefined) {
      setOpen(false);
      const res1 = await getAuctions();
      setAuctions(res1);
    }
  };
  
  return (
    <div className="container">
      <div className="page-title">GESTIONE ASTE</div>
      { !showDetail && 
        <>
          <div className="justify-content-end mt-3 mb-3">
            <Button onClick={handleAdd}>Nuova Asta</Button>
          </div>
          <>
            {
              auctions.map((a: IAuction) => {
              return (
                <>
                  <div key={a.ID} className="row">
                    <div className="col-8 team">
                      <img src={`${process.env.PUBLIC_URL}/img/${a.Team}.png`} style={{ width: "30px" }} />
                      <div className=" jersey">{a.JerseyNumber!.padStart(2, '0')}</div>
                      <div>{a.Fullname}</div>
                    </div>         
                    <div className="col-4 listButtonRow">
                      <Button icon={<EditFilled/>} onClick={() => handleEdit(a)} ></Button>
                      <Button icon={<DeleteFilled/>} onClick={() => handleDelete(a)} ></Button>
                      <Button icon={<ClockRegular />} onClick={() => handleHistory(a)} ></Button>
                    </div>
                  </div>
                  <div className="col-12" style={{borderBottom: '1px solid #ccc', margin:'10px 0 10px 0'}}></div>
                </>
              )})
            }
          </>
        </>
      } 
      {showDetail &&
        <>
          <>
            {
              offers.map((offer: IBestOffer) => {
              return (
                <>
                  <div key={offer.AuctionID} className="row">
                    <div className="col-2 team">
                      <img src={`${process.env.PUBLIC_URL}/img/${offer.Team}.png`} style={{ width: "30px" }} />
                      <div className=" jersey">{offer.JerseyNumber!.padStart(2, '0')}</div>
                    </div>                
                    <div className="col-7 fullname" style={{fontSize:"12pt"}}>{offer.Fullname}</div>
                    <div className="col-3 price">{offer.Price}€</div>
                  </div>
                  <div className="col-12" style={{fontSize:'8px', textAlign:'right'}}>
                    {offer.UserName} {format(offer.AuctionData, "dd/MM/yyyy HH:mm:ss")}
                  </div>
                </>
              )})}
          </>
          <Button appearance="primary" onClick={() => setShowDetail(false)}>Chiudi</Button>
        </>
      }
      {/* <table className="table table-sm">
        <thead>
          <tr>            
            <th scope="col">#</th>
            <th scope="col">Squadra</th>
            <th scope="col">Nome</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {
            auctions.map((a:IAuction) => {
              return (
                <tr key={a.ID}> 
                  <td className="td50">{a.JerseyNumber}</td>
                  <td>{a.Team}</td>
                  <td>{a.Fullname}</td>
                  <td className="td100">
                    <Button icon={<EditFilled/>} onClick={() => handleEdit(a)} ></Button>
                    <Button icon={<DeleteFilled/>} onClick={() => handleDelete(a)} ></Button>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table> */}
      <div>{error}</div>
      <div style={{marginBottom:"50px"}}></div>
      <Dialog open={open} onOpenChange={(event, data) => setOpen(data.open)}>          
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Modifica asta</DialogTitle>
            <DialogContent style={{overflowX:'hidden'}}>
              <div className="row">
                <div className="col-4"><Label required htmlFor={"jersey"}>Numero</Label></div>
                <div className="col-8"><Input required id={"jersey"} value={jersey} onChange={(e) => setJersey(e.target.value)} /></div>
              </div>
              <div className="row">
                <div className="col-4"><Label required htmlFor={"team"}>Squadra</Label></div>
                <div className="col-8"><Input required id={"team"} value={team} onChange={(e) => setTeam(e.target.value)} /></div>
              </div>
              <div className="row">
                <div className="col-4"><Label required htmlFor={"name"}>Nome</Label></div>
                <div className="col-8"><Input required id={"name"} value={name} onChange={(e) => setName(e.target.value)} /></div>
              </div>
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary">Chiudi</Button>
              </DialogTrigger>
              <Button appearance="primary" onClick={onSave}>Salva</Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
};